"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.variants = void 0;
const react_1 = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const immutable_1 = require("immutable");
const classnames_1 = __importDefault(require("classnames"));
const lodash_1 = require("lodash");
const Chip_1 = __importDefault(require("@mui/material/Chip"));
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const Done_1 = __importDefault(require("@mui/icons-material/Done"));
const Cancel_1 = __importDefault(require("@mui/icons-material/Cancel"));
const tags_1 = require("companion-app-components/flux/tags");
const Input_1 = __importDefault(require("components/QTag/Input"));
const styles_1 = require("./styles");
exports.variants = Object.freeze({
    NORMAL: 'normal',
    EDIT: 'edit',
    NEW: 'new',
});
const useStyle = (0, mui_1.makeStyles)()(styles_1.tagStyles);
const QTag = ({ classname = '', tagVariant: initialTagVariant = exports.variants.NORMAL, tagValue: initialTagValue, id, index, changeUiState, handleSave, handleDelete, removeNewItem, showSaveChangesDialog, tagsCharFilter = [], setEditingTag, }) => {
    const [tagVariant, setTagVariant] = (0, react_1.useState)(initialTagVariant);
    const [tagValue, setTagValue] = (0, react_1.useState)(initialTagValue);
    const [initialValue, setInitialValue] = (0, react_1.useState)(initialTagValue);
    const chipRef = (0, react_1.useRef)(null);
    const { classes } = useStyle();
    (0, react_1.useEffect)(() => {
        setTagVariant(initialTagVariant);
    }, [initialTagVariant]);
    (0, react_1.useEffect)(() => {
        setTagValue(initialTagValue);
        setInitialValue(initialTagValue);
        setTagVariant(initialTagVariant);
    }, [initialTagValue, initialTagVariant]);
    const changeVariant = (variant = exports.variants.NORMAL) => {
        if (changeUiState) {
            changeUiState(id, variant);
        }
    };
    const sanitizeInput = (text = '') => {
        let sanitizeText = text;
        tagsCharFilter.forEach((char) => {
            sanitizeText = sanitizeText.split(char).join('');
        });
        return sanitizeText;
    };
    const handleChange = (e) => {
        const value = sanitizeInput(e.target.value);
        setTagValue(value);
        // @ts-expect-error: Property 'id' is optional in type 'Record<TagProps> 
        setEditingTag === null || setEditingTag === void 0 ? void 0 : setEditingTag(tags_1.tagsTypes.mkTag({ id, name: value }));
    };
    const onSave = () => {
        const trimmedTagValue = tagValue.trim();
        if (trimmedTagValue !== '') {
            handleSave(id, trimmedTagValue, () => {
                var _a;
                changeVariant();
                (_a = chipRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                setInitialValue(trimmedTagValue);
            });
        }
    };
    const onCancel = () => {
        const cancelCallback = () => {
            if (tagVariant === exports.variants.EDIT) {
                setTagValue(initialValue);
                changeVariant();
            }
            if (tagVariant === exports.variants.NEW) {
                removeNewItem === null || removeNewItem === void 0 ? void 0 : removeNewItem();
            }
        };
        if (tagValue === initialValue) {
            cancelCallback();
        }
        else {
            showSaveChangesDialog(onSave, cancelCallback, tagValue);
        }
    };
    const onChange = (e) => {
        handleChange(e);
    };
    const onEdit = () => {
        changeVariant(exports.variants.EDIT);
    };
    const onKeyDown = (event) => {
        if (event.key === 'Enter') {
            onSave();
        }
        else if (event.key === 'Escape') {
            onCancel();
        }
    };
    const onDelete = () => {
        handleDelete(id);
    };
    const getProps = () => {
        const isEditing = tagVariant !== exports.variants.NORMAL;
        const baseId = `tag-${index}`;
        const inputLabel = (inputId, newPlaceholder) => (<Input_1.default id={inputId} key={`${inputId}-key`} isEditing={isEditing} onChange={onChange} onKeyDown={onKeyDown} tagValue={tagValue} placeholder={newPlaceholder} hideHiddenSpan/>);
        const QTagProps = (0, immutable_1.Record)({
            id: baseId,
            key: baseId,
            className: [classname, classes.QTag].join(' '),
            classes: {},
            label: undefined,
            deleteIcon: undefined,
            onClick: undefined,
            onDelete: undefined,
            variant: 'default',
            clickable: false,
        });
        let itemProps = new QTagProps();
        switch (tagVariant) {
            case exports.variants.NORMAL:
                itemProps = new QTagProps({
                    label: inputLabel(`${baseId}-normal-field`),
                    deleteIcon: <Cancel_1.default id={`${baseId}-delete-button`}/>,
                    clickable: true,
                    onClick: onEdit,
                    onDelete,
                    classes: { root: classes.chipRoot },
                });
                break;
            case exports.variants.EDIT:
                itemProps = new QTagProps({
                    label: inputLabel(`${baseId}-edit-field`, 'Edit Tag'),
                    deleteIcon: <Done_1.default id={`${baseId}-save-button`}/>,
                    variant: 'outlined',
                    onDelete: onSave,
                    classes: { outlined: classes.chipOutlined, deleteIcon: classes.outlinedIcon },
                });
                break;
            case exports.variants.NEW:
                // eslint-disable-next-line no-case-declarations
                const addIconClasses = (0, classnames_1.default)({ [classes.disabledAddBtn]: tagValue.trim() === '' });
                itemProps = new QTagProps({
                    label: inputLabel(`${baseId}-new-field`, 'New Tag'),
                    deleteIcon: <Add_1.default id={`${baseId}-create-button`} className={addIconClasses}/>,
                    variant: 'outlined',
                    onDelete: onSave,
                    classes: { outlined: classes.chipOutlined, deleteIcon: classes.outlinedIcon },
                });
                break;
            default:
                break;
        }
        const qTagItemProps = itemProps.toJS();
        return qTagItemProps.onClick === undefined ? (0, lodash_1.omit)(qTagItemProps, ['onClick']) : qTagItemProps;
    };
    return (<div>
      <Chip_1.default ref={chipRef} onBlur={onCancel} {...getProps()}/>
    </div>);
};
exports.default = QTag;
